import React from 'react';
import PropTypes from 'prop-types';
import AdSense from './AdSense';

/**
 * AdBanner Component
 * 
 * A horizontal banner ad (typically 728x90 pixels)
 * Commonly used in headers and footers
 * 
 * @param {Object} props Component props
 * @param {string} props.adSlot The ad unit ID
 * @param {boolean} props.responsive Whether the ad should be responsive
 * @param {boolean} props.inArticle Whether to use the in-article layout
 * @param {Object} props.style Additional inline styles
 * @param {string} props.className Additional CSS classes
 */
const AdBanner = ({
  adSlot = 'banner-ad-slot',
  responsive = true,
  inArticle = false,
  style = {},
  className = ''
}) => {
  const bannerStyle = {
    width: responsive ? '100%' : '728px',
    height: inArticle ? 'auto' : '90px',
    minHeight: inArticle ? '200px' : '90px',
    maxWidth: '100%',
    ...style
  };

  return (
    <AdSense
      adSlot={adSlot}
      adFormat={inArticle ? "fluid" : "horizontal"}
      adLayout={inArticle ? "in-article" : null}
      style={bannerStyle}
      className={`ad-banner ${className || ''}`}
    />
  );
};

AdBanner.propTypes = {
  adSlot: PropTypes.string,
  responsive: PropTypes.bool,
  inArticle: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string
};

export default AdBanner; 